module.exports = __webpack_public_path__ + "img/1.186941df.jpg";